import { createSelector } from '@reduxjs/toolkit';
import { selectCapitalGainsLosses } from '../../store/selector';

export const selectCGTConfiguration = createSelector(selectCapitalGainsLosses, (capitalGainsAndLosses) => {
  return capitalGainsAndLosses.configurationState;
});
